// TODO: We still need to find a well-organized and concise structure
// Maybe separate strings into global and component groups?
export const languageStrings = {
  activeProduct: 'Für dieses Konto besteht bereits ein aktives Abo.',
  alreadyAcquiredEntitlements: {
    pur: {
      heading: 'Mit Ihrem STANDARD Abo erhalten Sie derStandard.at PUR zum Vorteilspreis.',
      explanation: (ctaUrl: string) =>
        `Für ein werbe- und trackingfreies Leseerlebnis: <a href="${ctaUrl}" rel="noreferrer" target="_blank"><em>derStandard.at PUR aktivieren</em></a>.`
    },
    smart: {
      heading: 'Mit Ihrem STANDARD Abo nutzen Sie bereits viele Vorteile von STANDARD Smart.',
      explanation: (ctaUrl: string) =>
        `Für ein zusätzliches werbe- und trackingfreies Leseerlebnis: <a href="${ctaUrl}" rel="noreferrer" target="_blank"><em>derStandard.at PUR aktivieren</em></a>.`
    }
  },
  subscriptionOnHoliday: {
    heading: 'Ein Abo-Wechsel ist derzeit nicht möglich.',
    explanation: (endDate: string) => `Ihr Abo ist bis ${endDate} pausiert. Ein Wechsel ist erst danach wieder möglich.`,
    explanationWithoutDate: 'Ihr Abo ist derzeit pausiert. Ein Wechsel ist erst nach Ende der Pause wieder möglich.'
  },
  notQualifiedForCheaperPur: {
    heading: 'Nur für bestehende STANDARD Abonnent:innen.',
    explanation: (ctaUrl: string) => `Kein Abo? → <a href="${ctaUrl}"><em>Zum PUR‑Angebot</em></a>.`
  },
  smartPlusPurHint: {
    heading: 'Lieber Smart behalten?',
    explanation: (ctaUrl: string) => `Und zusätzlich werbe‑ und trackingfrei lesen → <a href="${ctaUrl}" rel="noreferrer"><em>STANDARD Smart + PUR</em></a>.`
  },
  manualUpgradeOption:
    'Vielen Dank für Ihr Interesse am neuen Smart Abo. Als PUR Jahresabonnent:in wenden Sie sich bitte an das Aboservice-Team unter <a href="mailto:digitalabo@derStandard.at">digitalabo@derStandard.at</a>, das Ihnen beim Umstieg behilflich sein wird.',
  buttons: {
    backToStart: 'Zur Startseite',
    buy: 'Kaufen',
    cancel: 'Abbrechen',
    changePaymentMethod: 'Bezahlmethode ändern',
    loading: 'Wird geladen',
    mySubscriptions: 'Meine Abonnements',
    next: 'Weiter',
    redeemVoucher: 'Gutschein einlösen',
    tryAgain: 'Erneut versuchen'
  },
  dialogs: {
    cookie: {
      action: 'OK',
      description: 'Mit der weiteren Nutzung stimme ich der Verwendung von Cookies für die Webanalyse und digitalen Werbemaßnahmen zu.',
      goToPrivacyPolicy: 'Zur Datenschutzerklärung'
    },
    invalidVoucher: {
      body: 'Bitte überprüfen Sie Ihre Eingabe',
      title: 'Der Gutschein ist leider nicht gültig'
    },
    validVoucher: {
      body: (voucherCode: string) => `Der Gutschein <strong>${voucherCode}</strong> ist nun aktiv`,
      title: 'Gutschein erfolgreich eingelöst'
    }
  },
  forms: {
    countryList: {
      label: 'In welchem Land leben Sie?'
    },
    input: {
      label: {
        zipCity: 'PLZ & Ort',
        doorNumber: 'Tür',
        firstName: 'Vorname',
        floor: 'Stock',
        houseNumber: 'Hausnummer',
        lastName: 'Nachname',
        stairs: 'Stiege',
        street: 'Straße'
      },
      validationError: {
        zipCity: 'Bitte wählen Sie einen gültigen Ort aus der Liste aus',
        doorNumber: 'Die Türnummer muss mindestens ein Zeichen lang sein',
        firstName: 'Der Vorname muss mindestens 2 Zeichen lang sein',
        houseNumber: 'Die Hausnummer muss mindestens 1 Zeichen lang sein und darf nur die folgenden Sonderzeichen enthalten: + - / \\',
        lastName: 'Der Nachname muss mindestens 2 Zeichen lang sein'
      }
    },
    titleList: {
      label: 'Titel (optional)'
    },
    voucherCode: {
      label: 'Gutscheincode',
      placeholder: 'Geben Sie hier Ihren Gutscheincode ein'
    }
  },
  more: {
    benefits: 'Abovorteile',
    goToOffers:
      'Profitieren Sie von vielen Vorteilen – <a href="https://abo.derstandard.at/abovorteile/" rel="noopener noreferrer" target="_blank">alle aktuellen Angebote im Überblick</a>.',
    header: 'Haben Sie Fragen?',
    productQuestions: (contactEmail: string) =>
      `Antworten finden Sie in den <a href="https://abo.derstandard.at/fragen-antworten" target="_blank" rel="noopener noreferrer">FAQs</a>, oder Sie schreiben uns eine E‑Mail an <a href="mailto:${contactEmail}">${contactEmail}</a>.`
  },
  payment: {
    body: 'Für die Bestellung wird folgende, bei uns hinterlegte Bezahlmethode verwendet:',
    errors: {
      noValidPaymentMethod: 'Für dieses Konto ist keine gültige Bezahlmethode hinterlegt.'
    },
    heading: 'Zahlung',
    iframe: {
      title: 'Bezahl-iFrame'
    }
  },
  product: {
    updatedPrice: 'Ihre Angebotsdetails wurden soeben aktualisiert:'
  },
  upgrade: {
    currentProductKnown: (currentProduct: string, bundleName: string) =>
      `Ihr <strong>${currentProduct}</strong>-Abo wird auf <strong>${bundleName}</strong> umgestellt – Ihre <strong>Gutschrift</strong> wird bei den nächsten Zahlungen berücksichtigt.`,
    currentProductUnknown: (bundleName: string) =>
      `Ihr Abo wird auf <strong>${bundleName}</strong> umgestellt – Ihre <strong>Gutschrift</strong> wird bei den nächsten Zahlungen berücksichtigt.`
  }
} as const;
